import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { interceptors } from '@barracuda/shared-api';
function isExpired(token) {
    return new Date() > token.expiresAt;
}
const parseToken = (token) => {
    const decodedPayload = jwt_decode(token);
    return {
        raw: token,
        expiresAt: new Date(decodedPayload.exp * 1000),
        ...decodedPayload
    };
};
const userAgentInterceptor = (userAgent) => (req) => {
    if (userAgent) {
        req.headers.set('User-Agent', userAgent);
    }
    return req;
};
const authorizationInterceptor = (baseUrl, tokenRef) => (req) => {
    if (req.url && !req.url.startsWith(baseUrl)) {
        // external requests, eg. AWS
        return req;
    }
    if (!tokenRef.current?.token) {
        throw new Error(`Attempt to call ${req.url} without AUTHORIZATION`);
    }
    if (isExpired(tokenRef.current.token)) {
        throw new Error(`TDA token expired token=${tokenRef.current.token.raw}`);
    }
    req.headers.set('Authorization', `Bearer ${tokenRef.current.token.raw}`);
    return req;
};
export const makeTDAClientProtocol = (options) => {
    const tokenRef = { current: null };
    const getToken = () => tokenRef.current?.token?.raw;
    const setToken = (token) => {
        const parsedToken = parseToken(token);
        tokenRef.current = {
            token: parsedToken
        };
    };
    if (options.token) {
        setToken(options.token);
    }
    const httpProvider = axios.create({
        adapter: ['http', 'fetch', 'xhr']
    });
    httpProvider.defaults.timeout = 120000;
    httpProvider.interceptors.request.use(authorizationInterceptor(options.baseUrl, tokenRef));
    httpProvider.interceptors.request.use(userAgentInterceptor(options.userAgent));
    httpProvider.interceptors.response.use((response) => response, (error) => Promise.reject(interceptors.sanitizeAuthorizationHeaderFromError(error)));
    return {
        httpProvider,
        makeUrl: (url) => `${options.baseUrl}${url}`,
        deleteToken: () => {
            tokenRef.current = null;
        },
        getToken,
        setToken
    };
};
//# sourceMappingURL=protocol.js.map